import {useContext} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {useQueryClient} from '@tanstack/react-query';
import {ToastType} from 'patient-ping-remedy/packages/toast';
import {NotificationAlert} from '@/api/dto/notification';
import {GENERICERROR} from '@manual_encounters/constants/BannerMessages';
import {CarecoApiContext} from '@/app-context/careco-api-context';
import {useNotificationStore} from '@/store/notification_store';
import {useRosterStore} from '@/store/roster_store';
import {useAlertStore} from '@/store/alert_store';
import Helpers from '@/helpers/helpers';
import {log} from "@/helpers/logger";

export function useNotificationItem() {
  const { carecoApi } = useContext(CarecoApiContext);
  const queryClient = useQueryClient();
  const currentRoster = useRosterStore((state) => state.currentRoster);
  const addAlert = useAlertStore((state) => state.addAlert);

  const [isApiLoading, setApiLoading] = useNotificationStore(useShallow((state) => [
    state.isApiLoading,
    state.setApiLoading,
  ]));

  const setNotificationViewed = (id: number, viewed: boolean) => {
    setApiLoading(true);
    carecoApi?.putNotificationViewed(id, viewed)
      .then(() => {
        addAlert({
          type: ToastType.SUCCESS,
          content: viewed ? NotificationAlert.NOTIFICATION_MARKED_AS_READ : NotificationAlert.NOTIFICATION_MARKED_AS_UNREAD,
        });
        void queryClient.invalidateQueries({ queryKey: ['notifications', currentRoster?.id ?? 'all', true] });
        void queryClient.invalidateQueries({ queryKey: ['notifications', currentRoster?.id ?? 'all', false] });
      })
      .catch(error => {
        addAlert({
          content: `${NotificationAlert.FAILED_TO_MARK_NOTIFICATION} ${GENERICERROR} ${Helpers.traceId(error)}`,
          type: ToastType.ERROR
        });
        log('error', 'Error updating notification viewed', error);
      })
      .finally(() => {
        setApiLoading(false);
      });
  };

  return {
    isApiLoading,
    setNotificationViewed,
  };
}
